/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import ReactHTMLParser from 'react-html-parser';

const cleanText = (str) => {
    const re = /<p>|<\/p>|<strong>|<\/strong>|\\n/g; // strips <p>,</p>,<strong>,</strong> and \n
    return ReactHTMLParser(str.replace(re, ''));
};

export default cleanText;
